import { ColumnSort } from '@tanstack/react-table';

import { COLUMN_NAMES } from '@/components/BaseTable/constants/column-constants';

export const TableType = {
  PDF: 'PDF',
  CODEBASE: 'CODEBASE',
  PAGE: 'PAGE',
  TEAM: 'TEAM',
} as const;

export type TableType = (typeof TableType)[keyof typeof TableType];

export const DEFAULT_SORTING: ColumnSort[] = [{ id: COLUMN_NAMES.UPDATED_AT, desc: true }];
